import Box from "@material-ui/core/Box";
import Button from "@material-ui/core/Button";
import Grid from "@material-ui/core/Grid";
import TextField from "@material-ui/core/TextField";
import Typography from "@material-ui/core/Typography";
import makeStyles from "@material-ui/core/styles/makeStyles";
import React, { useContext, useEffect, useState } from "react";
import { userJourneyContext } from "../../states/context/userJourneyContext";
import MockMilestoneTracker from "./MockMilestoneTracker";
import MockTooltipComponent from "./MockTooltipComponent";
import moment from "moment-timezone";

const mockSearchFilters = [
  "Taipei Textiles",
  "12087633979",
  "A",
];

const MockOrderManager = () => {
  const userContext = useContext(userJourneyContext);
  const classes = useStyles();
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (userContext.userJourneyInfo.payload.steps === 18) {
      setOpen(true);
      window.scrollTo({ top: 380, left: 0, behavior: 'smooth' });
    }
  }, [userContext.userJourneyInfo.payload.steps]);

  let dateObj = new Date();
  let date = dateObj.getDate();
  let year = dateObj.getFullYear();
  let month = dateObj.getMonth();

  const changeOriginalDate = (dObj, d, m, y, n) => {
    if (d + n > moment(dObj).daysInMonth()) {
      date = d + n - moment(dObj).daysInMonth();
      if (m >= 11) {
        month = 0;
        year = y + 1
      } else {
        month = m + 1
      }
    } else {
      date = d + n;
    }
    dateObj = new Date(year, month, date);
    return moment(dateObj).format('ll');
  }

  return (
    <div className={classes.root}>
      <Grid container style={{ background: "rgb(247, 248, 252)", paddingTop: "16px", zIndex: "999" }}>
        {mockSearchFilters.map((filter) => (
          <Box
            className={classes.boxStyle}
            sx={{ display: "flex", alignItems: "flex-end" }}
          >
            <i
              style={{
                color: "#94A3B8",
                fontSize: "18px",
                margin: "8px",
              }}
              className={"fa-solid fa-magnifying-glass"}
            />
            <TextField
              fullWidth
              placeholder={filter}
              InputProps={{ disableUnderline: true }}
              className={classes.textfieldStyle}
            />
          </Box>
        ))}
      </Grid>
      <div style={{ zIndex: "999" }}>
        <MockTooltipComponent
          placement="right"
          open={open}
          popper={classes.globalRiskNotification}
          tooltipArrowStyle={classes.locationArrowStyle}
          title={
            <>
              <Typography className={classes.tooltipTitleStyle}>
                Click Global Risks
              </Typography>
              <p className={classes.tooltipTextStyle}>
                Global risks affect your suppliers and could impact your delivery
                time too.
              </p>
              <p className={classes.tooltipTextStyle}>
                Take a look to see if there are any ongoing risks to your purchase
                orders that you should be aware of.
              </p>
              <Typography className={classes.stepTextStyle} style={{marginTop:"-20px"}}>
                (15/19)
              </Typography>
            </>
          }
          child={
            <Grid container style={{ background: "rgb(247, 248, 252)" }}>
              <Grid item xs={4}>
                <div className={`${classes.latestDateTimeCard}`} style={{ gap: "0" }}>
                  <>
                    <Typography className={classes.supplierCardTitle}>
                      LATEST<span><br /> EX-MILL DATE</span>
                    </Typography>
                    <div style={{ marginBottom: "11px" }}>
                      <Typography className={classes.mileStoneCardValue}>
                        {changeOriginalDate(dateObj, date, month, year, 21)}
                      </Typography>
                      {<Typography className={classes.mileStoneDateUpdate}>Last Updated: 3 days ago</Typography>}
                    </div>
                    <Button
                      variant="contained"
                      size="small"
                      className={classes.editDateCardButton}
                    >
                      {"Edit Date"}
                    </Button>
                  </>
                </div>
              </Grid>
              <Grid item xs={4}>
                <div className={`${classes.latestDateTimeCard}`} style={{ gap: "0" }}>
                  <>
                    <Typography className={classes.supplierCardTitle}>
                      LATEST<span><br /> EX-COUNTRY DATE</span>
                    </Typography>
                    <div style={{ marginBottom: "11px" }}>
                      <Typography className={classes.mileStoneCardValue}>
                        {changeOriginalDate(dateObj, date, month, year, 5)}
                      </Typography>
                      {<Typography className={classes.mileStoneDateUpdate}>Last Updated: 2 days ago</Typography>}
                    </div>
                    <Button
                      variant="contained"
                      size="small"
                      className={classes.editDateCardButton}
                    >
                      {"Edit Date"}
                    </Button>
                  </>
                </div>
              </Grid>
              <Grid item xs={4}>
                <div className={`${classes.latestDateTimeCard}`} style={{ gap: "0" }}>
                  <>
                    <Typography className={classes.supplierCardTitle}>
                      ESTIMATED<span><br /> TIME OF ARRIVAL</span>
                    </Typography>
                    <div style={{ marginBottom: "11px" }}>
                      <Typography className={classes.mileStoneCardValue}>
                        {changeOriginalDate(dateObj, date, month, year, 42)}
                      </Typography>
                      {<Typography className={classes.mileStoneDateUpdate}>Last Updated: 2 days ago</Typography>}
                    </div>
                    <Button
                      variant="contained"
                      size="small"
                      className={classes.editDateCardButton}
                    >
                      {"Edit Date"}
                    </Button>
                  </>
                </div>
              </Grid>
            </Grid>
          }
        />
      </div>
      <MockMilestoneTracker />
    </div>
  );
};

export default MockOrderManager;

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    flexDirection: "column",
  },
  boxStyle: {
    border: "1px solid #E2E8F0",
    marginBottom: "16px",
    backgroundColor: "#FFFFFF",
    marginRight: "8px",
  },
  tooltipTextStyle: {
    marginTop: "0px",
    fontSize: "14px",
    fontFamily: "Inter",
  },
  tooltipTitleStyle: {
    marginTop: "0px",
    fontSize: "20px",
    fontFamily: "Inter",
  },
  globalRiskNotification: {
    marginLeft: `calc(-100% + 240px)`,
    position: "fixed !important",
    marginTop: "-55px",
    zIndex: "999"
  },
  locationArrowStyle: {
  },
  latestDateTimeCard: {
    boxSizing: "border-box",
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    padding: "16px",
    gap: "20px",
    width: "93%",
    height: "200px",
    background: "#FFFFFF",
    border: "1px solid #B2BDC7",
    flex: "none",
    order: 0,
    flexGrow: 1,
  },
  supplierCardTitle: {
    padding: "3px",
    color: "#363740",
    fontWeight: 700,
    fontFamily: "Inter",
  },
  mileStoneCardValue: {
    paddingBlock: "3px",
    fontSize: "24px",
    color: "#363740",
    fontFamily: "Inter",
    fontWeight: "500"
  },
  editDateCardButton: {
    fontFamily: 'Inter',
    background: "#FFFFFF",
    color: "#334155",
    textTransform: "capitalize",
    border: "1px solid #000000",
    "&:hover": {
      backgroundColor: "white",
    },
  },
  stepTextStyle: {
    padding: "0px",
    margin: "0px",
    fontSize: "14px",
    textAlign: "end",
    marginTop: "-10px",
    marginBottom: "-10px",
  }
}));
